export const ACTIVE_CHAT_COOKIE = 'activeChat';
export const ACTIVE_CHAT_COOKIE_EXPIRY = 60 * 24; // 1 day in minutes
